/* eslint-disable max-len */
import { RouteConfig } from "vue-router";

import { metaRequireGuest } from "@/router/meta-constants";

import LoginPage from "@/views/mobile/authenticate/Login.vue";
import ForgotPasswordPage from "@/views/mobile/authenticate/ForgotPassword.vue"
import RegisterPage from "@/views/mobile/authenticate/Register.vue";

const authenticateRoutes: Array<RouteConfig> = [
    {
        path: "/login",
        name: "Login",
        meta: metaRequireGuest,
        component: LoginPage,
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        meta: metaRequireGuest,
        component: ForgotPasswordPage,
    },
    {
        path: "/register",
        name: "Register",
        meta: { isShowFooter: true, guest: true },
        component: RegisterPage,
    },
];

export default authenticateRoutes;
